import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#d32f2f" },
    secondary: { main: "#111827" },
    background: { default: "#ffffff", paper: "#ffffff" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Apple Color Emoji", "Segoe UI Emoji"',
    h1: { fontWeight: 800, fontSize: "3rem", lineHeight: 1.1 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiContainer: {
      defaultProps: { maxWidth: "lg" },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10, paddingLeft: 18, paddingRight: 18 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow:
            "0 2px 10px rgba(0,0,0,0.06), 0 12px 30px rgba(0,0,0,0.06)",
          transition: "transform .2s ease, box-shadow .2s ease",
          willChange: "transform",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { backdropFilter: "saturate(180%) blur(8px)" },
      },
    },
  },
});

export default theme;
